import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics'
import { compare } from 'compare-versions'
import { Utils } from '../../utils'
import { reactAppStage } from '../../utils/reactAppStage'

const versionCheck = async () => {
    if (reactAppStage() !== 'demo') return false
    const v = await Utils.getVersion()
    if (v === 'webView') return false
    const requiredVersion = '0.9.26'

    return compare(v, requiredVersion, '>=')
}

export const setUserId = async (userId: string) => {
    if (await versionCheck())
        FirebaseAnalytics.setUserId({
            userId: userId,
        })
}
export const setCollectionEnabled = async (enabled: boolean) => {
    if (await versionCheck())
        FirebaseAnalytics.setCollectionEnabled({
            enabled: enabled,
        })
}

export const logEvent = async (name: string, params: any) => {
    if (await versionCheck())
        FirebaseAnalytics.logEvent({
            name: name,
            params: params,
        })
}

export const setUserProperty = async (name: string, value: string) => {
    if (await versionCheck())
        FirebaseAnalytics.setUserProperty({
            name: name,
            value: value,
        })
}

export const resetAnalyticsData = async () => {
    if (await versionCheck()) FirebaseAnalytics.reset()
}

export const appInstanceId = async () => {
    if (await versionCheck()) return FirebaseAnalytics.getAppInstanceId()
    return ''
}

export const setScreenName = async (name: string) => {
    if (await versionCheck())
        FirebaseAnalytics.setScreenName({ screenName: name })
}
